import { Directive } from '@angular/core';

@Directive({
  selector: '[psPageTitle]',
  standalone: true,
  host: {
    class: 'ps-page-title',
    id: 'page-title',
  },
})
export class PageTitleDirective {}
